
import React from 'react'
import { Template } from '../components/template';
const config = {
    "name": "我说的",
    "url": "/woshuode/",
    "gif": "/template/woshuode.gif",
    "config": [
        {
            "default": "六点下班我是一定要走的",
            "startTime": 0.4,
            "endTime": 2.2
        },
        {
            "default": "耶稣也留不住我",
            "startTime": 2.6,
            "endTime": 3.7
        },
        {
            "default": "我说的",
            "startTime": 3.8,
            "endTime": 4.6
        }
    ]
}

export { config };
export default () => (
    <Template element={config} />
)